import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList from "../Data.List/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dOrdered from "../Data.Map.Ordered/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Data$dValidation$dSemigroup from "../Data.Validation.Semigroup/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Effect$dConsole from "../Effect.Console/index.js";
import * as FieldTest from "../FieldTest/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Network$dJsonRPC from "../Network.JsonRPC/index.js";
import * as Record$dExtra from "../Record.Extra/index.js";
import * as Restaumatic$dACS$dRPC$dSites$dTypes from "../Restaumatic.ACS.RPC.Sites.Types/index.js";
import * as Restaumatic$dACS$dTypes$dCrossSellingRanking from "../Restaumatic.ACS.Types.CrossSellingRanking/index.js";
import * as Restaumatic$dACS$dTypes$dWeights from "../Restaumatic.ACS.Types.Weights/index.js";
import * as Restaumatic$dAnalytics$dTypes$dEvent from "../Restaumatic.Analytics.Types.Event/index.js";
import * as Restaumatic$dCrossSelling$dSuggestions from "../Restaumatic.CrossSelling.Suggestions/index.js";
import * as Restaumatic$dFeatureFlags from "../Restaumatic.FeatureFlags/index.js";
import * as Restaumatic$dForm$dAction from "../Restaumatic.Form.Action/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dFormField from "../Restaumatic.Form.FormField/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dMapping from "../Restaumatic.Form.Mapping/index.js";
import * as Restaumatic$dForm$dReadOnly from "../Restaumatic.Form.ReadOnly/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dCurrency from "../Restaumatic.I18n.Currency/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dMenu$dV2$dAllergens from "../Restaumatic.Menu.V2.Allergens/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dAllergen from "../Restaumatic.Menu.V2.Types.Allergen/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dAutomaticCrossSellingExperimentVariant from "../Restaumatic.Menu.V2.Types.AutomaticCrossSellingExperimentVariant/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCreatorCrossSellingPresentation from "../Restaumatic.Menu.V2.Types.CreatorCrossSellingPresentation/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic$dSite$dI18n from "../Restaumatic.Site.I18n/index.js";
import * as Restaumatic$dSite$dRPC from "../Restaumatic.Site.RPC/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dExtra$dPopover from "../Specular.Extra.Popover/index.js";
import * as Specular$dExtra$dShowMore from "../Specular.Extra.ShowMore/index.js";
import * as Specular$dExtra$dSlider from "../Specular.Extra.Slider/index.js";
import * as Specular$dFRP$dAsync from "../Specular.FRP.Async/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dExtra from "../Specular.FRP.Extra/index.js";
import * as Specular$dFRP$dHost from "../Specular.FRP.Host/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dIntersectionObserver from "../Specular.IntersectionObserver/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Type$dEquality from "../Type.Equality/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Utils$dTracking from "../Utils.Tracking/index.js";
import * as Utils$dURL from "../Utils.URL/index.js";
const $Mode = (tag, _1) => ({tag, _1});
const traverse = /* #__PURE__ */ (() => Data$dValidation$dSemigroup.traversableV.traverse(Effect.applicativeEffect))();
const getExperimentVariant = /* #__PURE__ */ FieldTest.getExperimentVariant(Restaumatic$dMenu$dV2$dTypes$dCreatorCrossSellingPresentation.experimentVariantCreatorC);
const getExperimentVariant1 = /* #__PURE__ */ FieldTest.getExperimentVariant(Restaumatic$dMenu$dV2$dTypes$dAutomaticCrossSellingExperimentVariant.experimentVariantAutomati);
const getExperimentVariant2 = /* #__PURE__ */ FieldTest.getExperimentVariant(Restaumatic$dACS$dTypes$dCrossSellingRanking.experimentVariantCrossSel);
const mempty = /* #__PURE__ */ (() => Data$dMap$dSerialized.monoidMap(Data$dOrd.ordString).mempty)();
const setExperimentVariant = /* #__PURE__ */ FieldTest.setExperimentVariant(Restaumatic$dACS$dTypes$dCrossSellingRanking.experimentVariantCrossSel);
const monadFRP = {MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder};
const withDynamic_ = /* #__PURE__ */ Specular$dFRP$dReplaceable.withDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)(monadFRP);
const display1 = /* #__PURE__ */ Restaumatic$dForm$dMapping.display(Data$dOrd.ordString)(monadFRP)(Specular$dDom$dBuilder.monadReplaceBuilder);
const queryReadOnly$p1 = /* #__PURE__ */ Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl);
const queryLax = /* #__PURE__ */ (() => queryReadOnly$p1.queryWith(Restaumatic$dForm$dInternal.Lax))();
const detailsIsSymbol = {reflectSymbol: () => "details"};
const traverse_ = /* #__PURE__ */ Data$dFoldable.traverse_(Specular$dInternal$dRIO.applicativeRIO)(Data$dFoldable.foldableMaybe);
const onVisibleIsSymbol = {reflectSymbol: () => "onVisible"};
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dList.toUnfoldable(Data$dUnfoldable.unfoldableArray);
  return x => $0(Data$dMap$dInternal.keys(x));
})();
const getFieldId = /* #__PURE__ */ (() => Restaumatic$dForm$dMapping.hasFieldIdItem(Data$dUUID.showUUID).getFieldId)();
const queryFormField$p1 = /* #__PURE__ */ Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl);
const quantityIsSymbol = {reflectSymbol: () => "quantity"};
const whenD = /* #__PURE__ */ Specular$dFRP$dExtra.whenD(monadFRP)(Specular$dDom$dBuilder.monadReplaceBuilder);
const addIsSymbol = {reflectSymbol: () => "add"};
const getGlobalLocale = /* #__PURE__ */ Restaumatic$dI18n.getGlobalLocale(Specular$dInternal$dRIO.monadEffectRIO);
const monadFRP1 = {MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dFRP$dHost.monadCleanupHost};
const uniqFinal = /* #__PURE__ */ Restaumatic$dForm$dFinal.uniqFinal(monadFRP1)({eq: /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)});
const asyncRequest = /* #__PURE__ */ Specular$dFRP$dAsync.asyncRequest(Specular$dInternal$dRIO.monadEffectRIO)(monadFRP1);
const sequenceRecord = /* #__PURE__ */ Record$dExtra.sequenceRecord()(/* #__PURE__ */ Record$dExtra.sequenceRecordCons({reflectSymbol: () => "productIds"})()(Restaumatic$dForm$dFinal.applyFinal)(/* #__PURE__ */ Record$dExtra.sequenceRecordSingle({
  reflectSymbol: () => "weights"
})()(Restaumatic$dForm$dFinal.functorFinal)()())()());
const mempty2 = /* #__PURE__ */ (() => Data$dSet.monoidSet(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.ordCartProductKey).mempty)();
const productKeyIsSymbol = {reflectSymbol: () => "productKey"};
const item = /* #__PURE__ */ Restaumatic$dForm$dMapping.item(/* #__PURE__ */ Restaumatic$dForm$dInternal.makeEmpty_Record()(/* #__PURE__ */ Restaumatic$dForm$dInternal.makeEmptyRecordCons(addIsSymbol)(/* #__PURE__ */ Restaumatic$dForm$dInternal.makeEmptyRecordCons(detailsIsSymbol)(/* #__PURE__ */ Restaumatic$dForm$dInternal.makeEmptyRecordCons(onVisibleIsSymbol)(/* #__PURE__ */ Restaumatic$dForm$dInternal.makeEmptyRecordCons(productKeyIsSymbol)(/* #__PURE__ */ Restaumatic$dForm$dInternal.makeEmptyRecordCons(quantityIsSymbol)(Restaumatic$dForm$dInternal.makeEmptyRecordNil)(Restaumatic$dForm$dFormField.makeEmptyFormField$pPartia)()())(Restaumatic$dForm$dReadOnly.makeEmptyReadOnly)()())(Restaumatic$dForm$dAction.makeEmptyAction)()())(Restaumatic$dForm$dReadOnly.makeEmptyReadOnly)()())(Restaumatic$dForm$dAction.makeEmptyAction)()()));
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Effect.applicativeEffect)(Data$dFoldable.foldableMaybe);
const insert1 = /* #__PURE__ */ Data$dMap$dOrdered.insert(Data$dOrd.ordString);
const queryRecordCons = /* #__PURE__ */ Restaumatic$dForm$dInternal.queryRecordCons(quantityIsSymbol)(Restaumatic$dForm$dInternal.queryRecordNil)(queryFormField$p1)()()()();
const queryRecordCons1 = /* #__PURE__ */ Restaumatic$dForm$dInternal.queryRecordCons(productKeyIsSymbol)(queryRecordCons)(queryReadOnly$p1)()()()();
const query = /* #__PURE__ */ (() => Restaumatic$dForm$dMapping.queryArrayTupleMapping1(Data$dOrd.ordString)(Restaumatic$dForm$dInternal.query_Record(Restaumatic$dForm$dInternal.asRecordRecord)()(queryRecordCons1)).queryWith(Restaumatic$dForm$dInternal.Strict))();
const query1 = /* #__PURE__ */ (() => Restaumatic$dForm$dMapping.queryArrayTupleMapping1(Data$dOrd.ordString)(Restaumatic$dForm$dInternal.query_Record(Restaumatic$dForm$dInternal.asRecordRecord)()(Restaumatic$dForm$dInternal.queryRecordCons(detailsIsSymbol)(queryRecordCons)(queryReadOnly$p1)()()()())).queryWith(Restaumatic$dForm$dInternal.Strict))();
const sum = /* #__PURE__ */ (() => Data$dFoldable.foldlArray(Data$dMoney$dRounded.additiveMoney.add)(0))();
const query2 = /* #__PURE__ */ (() => Restaumatic$dForm$dMapping.queryArrayTupleMapping1(Data$dOrd.ordString)(Restaumatic$dForm$dInternal.query_Record(Restaumatic$dForm$dInternal.asRecordRecord)()(Restaumatic$dForm$dInternal.queryRecordCons(detailsIsSymbol)(queryRecordCons1)(queryReadOnly$p1)()()()())).queryWith(Restaumatic$dForm$dInternal.Strict))();
const $$for = /* #__PURE__ */ (() => {
  const traverse2 = Data$dTraversable.traversableArray.traverse(Effect.applicativeEffect);
  return x => f => traverse2(f)(x);
})();
const InternalState = /* #__PURE__ */ $Mode("InternalState");
const ExternalState = value0 => $Mode("ExternalState", value0);
const mapEffect = dictMonadFRP => {
  const MonadCleanup1 = dictMonadFRP.MonadCleanup1();
  const Monad0 = MonadCleanup1.Monad0();
  const Bind1 = Monad0.Bind1();
  const MonadEffect0 = dictMonadFRP.MonadEffect0();
  const $$new = Specular$dRef.new(MonadEffect0);
  const subscribeEvent_ = Specular$dFRP$dBase.subscribeNode(MonadEffect0)(MonadCleanup1);
  const pure4 = Monad0.Applicative0().pure;
  return dyn => fn => Bind1.bind(MonadEffect0.liftEffect((() => {
    const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(dyn);
    return () => {
      const $1 = $0();
      return fn($1)();
    };
  })()))(initialResult => Bind1.bind($$new(initialResult))(ref => Bind1.bind(subscribeEvent_(x => {
    const $0 = fn(x);
    return () => {
      const x$1 = $0();
      return ref._2(_old => x$1)();
    };
  })(dyn))(() => pure4(ref._1))));
};
const mapEffectF = dictMonadFRP => {
  const map3 = dictMonadFRP.MonadCleanup1().Monad0().Bind1().Apply0().Functor0().map;
  const mapEffect1 = mapEffect(dictMonadFRP);
  return f => fn => map3(Restaumatic$dForm$dFinal.makeFinalV)(mapEffect1(f)(traverse(fn)));
};
const mapEffectF1 = /* #__PURE__ */ mapEffectF(monadFRP1);
const hasItems = field => Specular$dFRP$dBase.functorDynamic.map(x => x.length !== 0)(Restaumatic$dForm$dMapping.displayedItems(Data$dOrd.ordString)(field.selections));
const getPresentation = list => implementation => {
  if (list.tag === "CreatorCrossSelling") {
    if (implementation.tag === "Automatic") { return getExperimentVariant; }
    const $0 = FieldTest.clearVariant(Restaumatic$dMenu$dV2$dTypes$dCreatorCrossSellingPresentation.experimentVariantCreatorC)(Type$dProxy.Proxy);
    return () => {
      $0();
      return Restaumatic$dMenu$dV2$dTypes$dCreatorCrossSellingPresentation.Inline;
    };
  }
  return () => Restaumatic$dMenu$dV2$dTypes$dCreatorCrossSellingPresentation.Inline;
};
const getImplementation = catalogue => {
  const $0 = Restaumatic$dFeatureFlags.getFeatureFlag("automaticCrossSelling");
  return () => {
    const automaticFlag = $0();
    if (automaticFlag) {
      if (
        (() => {
          const go = (m$p, z$p) => {
            if (m$p.tag === "Leaf") { return z$p; }
            if (m$p.tag === "Node") { return go(m$p._5, false); }
            $runtime.fail();
          };
          return go(Data$dRecord.unsafeGet("crossSellingListsV2")(catalogue), true);
        })()
      ) {
        const variant = getExperimentVariant1();
        return (() => {
          if (variant.tag === "Enabled") { return Restaumatic$dCrossSelling$dSuggestions.Automatic; }
          if (variant.tag === "Disabled") { return Restaumatic$dCrossSelling$dSuggestions.Disabled; }
          $runtime.fail();
        })();
      }
      Effect$dConsole.log("[CrossSelling] AutomaticCrossSelling flag enabled, but restaurant has cross selling lists. Using static lists.")();
      FieldTest.clearVariant(Restaumatic$dMenu$dV2$dTypes$dAutomaticCrossSellingExperimentVariant.experimentVariantAutomati)(Type$dProxy.Proxy)();
      return Restaumatic$dCrossSelling$dSuggestions.Static;
    }
    return Restaumatic$dCrossSelling$dSuggestions.Static;
  };
};
const getAcsWeights = /* #__PURE__ */ (() => Restaumatic$dSite$dRPC.sitesRPC(Network$dJsonRPC.encodeRequest(Restaumatic$dACS$dRPC$dSites$dTypes.encodeGetAcsWeights)({
  encodeWithOptions: v => Restaumatic$dACS$dRPC$dSites$dTypes.encodeGetAcsWeights.encode
}))(Network$dJsonRPC.decodeResponse({decode: Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dACS$dTypes$dWeights.decodeWeights.decode)}))(Restaumatic$dACS$dRPC$dSites$dTypes.rPCMethodNameGetAcsWeight))();
const getWeights = v => v1 => {
  if (v1.tag === "Automatic") {
    return Effect$dAff._bind(Effect$dAff._liftEffect(getExperimentVariant2))(ranking => {
      if (ranking.tag === "Uniform") { return Effect$dAff._pure(mempty); }
      if (ranking.tag === "EmptyWeights") { return Effect$dAff._pure(mempty); }
      if (ranking.tag === "FromData") {
        return Effect$dAff._bind(getAcsWeights({restaurantId: v}))(response => {
          const $0 = (() => {
            if (response.tag === "Left") { return Data$dMaybe.Nothing; }
            if (response.tag === "Right") { return response._1; }
            $runtime.fail();
          })();
          const weights = (() => {
            if ($0.tag === "Nothing") { return mempty; }
            if ($0.tag === "Just") { return $0._1; }
            $runtime.fail();
          })();
          return Effect$dAff._bind((() => {
            const $1 = Effect$dAff._liftEffect(setExperimentVariant(Restaumatic$dACS$dTypes$dCrossSellingRanking.EmptyWeights));
            if (Restaumatic$dACS$dTypes$dWeights.eq(weights)(mempty)) { return $1; }
            return Effect$dAff._pure();
          })())(() => Effect$dAff._pure(weights));
        });
      }
      $runtime.fail();
    });
  }
  return Effect$dAff._bind(Effect$dAff._liftEffect(FieldTest.clearVariant(Restaumatic$dACS$dTypes$dCrossSellingRanking.experimentVariantCrossSel)(Type$dProxy.Proxy)))(() => Effect$dAff._pure(mempty));
};
const display = () => () => params => {
  const $0 = {inModal: false, ...params};
  const $1 = $0.field;
  const $2 = $0.inModal;
  const $3 = Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("row")])(Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.class_("col-md-12")
  ])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("m-crossup__header")])(Specular$dInternal$dRIO.bindImpl((() => {
    const $3 = Specular$dDom$dElement.el("h4")([Specular$dDom$dElement.class_("m-crossup__title")])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.crossup.title),
      {}
    )));
    if (!$2) { return $3; }
    if ($2) { return Specular$dInternal$dRIO.pureImpl(); }
    $runtime.fail();
  })())(() => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("m-crossup__nav splide__arrows")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("button")([
    Specular$dDom$dElement.attr("type")("button"),
    Specular$dDom$dElement.class_("m-crossup__arrow u-btn-unstyled splide__arrow splide__arrow--prev js-slider__prev"),
    Specular$dDom$dElement.attr("aria-label")(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.views.pagination.previous),
      {}
    )),
    Specular$dDom$dElement.attr("role")("button")
  ])(Specular$dDom$dElement.el("i")([Specular$dDom$dElement.class_("icon-btn icon-left")])(Restaumatic$dPrelude$dSpecular.wempty)))(() => Specular$dDom$dElement.el("button")([
    Specular$dDom$dElement.attr("type")("button"),
    Specular$dDom$dElement.class_("m-crossup__arrow u-btn-unstyled splide__arrow splide__arrow--next js-slider__next"),
    Specular$dDom$dElement.attr("aria-label")(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.views.pagination.next),
      {}
    )),
    Specular$dDom$dElement.attr("role")("button")
  ])(Specular$dDom$dElement.el("i")([Specular$dDom$dElement.class_("icon-btn icon-right")])(Restaumatic$dPrelude$dSpecular.wempty)))))))))(() => Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.class_("row")
  ])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("col-md-12")])(Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.class_("m-crossup__body splide__track")
  ])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("m-crossup__list splide__list js-slider__list")])(display1($1.selections)(selectionItem => withDynamic_(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(queryLax(Data$dRecord.unsafeGet("details")(selectionItem.subform))))(traverse_(details => Specular$dDom$dElement.el("article")([
    Specular$dDom$dElement.class_("m-crossup__item splide__slide"),
    Specular$dIntersectionObserver.observe()()({
      threshold: 0.5,
      onVisible: (() => {
        const $3 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(Data$dRecord.unsafeGet("onVisible")(selectionItem.subform).effect._1);
        return () => {
          const e = $3();
          return e()();
        };
      })(),
      debounceTimeMs: 500.0
    })
  ])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("m-crossup__item-content")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("picture")([
    Specular$dDom$dElement.class_("m-crossup__item-picture")
  ])(Specular$dDom$dElement.el("img")([
    Specular$dDom$dElement.class_("m-crossup__item-img"),
    Specular$dDom$dElement.attr("loading")("lazy"),
    Specular$dDom$dElement.attr("src")(Utils$dURL.setQueryParams([
      Data$dTuple.$Tuple("auto", "compress"),
      Data$dTuple.$Tuple("crop", "focalpoint"),
      Data$dTuple.$Tuple("fit", "crop"),
      Data$dTuple.$Tuple("max-h", "200"),
      Data$dTuple.$Tuple("max-w", "400")
    ])((() => {
      if (details.photo.tag === "Nothing") { return Utils$dURL.imgixUrl + "/uploads/media_library/3759b3df5982ce78756f289321cb79d3.png"; }
      if (details.photo.tag === "Just") { return Utils$dURL.imgixUrl + details.photo._1; }
      $runtime.fail();
    })())),
    Specular$dDom$dElement.attr("alt")(details.name)
  ])(Restaumatic$dPrelude$dSpecular.wempty)))(() => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("u-flex-grow")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("h4")([
    Specular$dDom$dElement.class_("u-my0 u-font-size-inherit")
  ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("m-crossup__item-title")])(Specular$dDom$dElement.text(details.name)))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => {
    const $3 = details.allergens.tag === "Leaf";
    const $4 = Specular$dDom$dElement.el("button")([
      Specular$dDom$dElement.attr("type")("button"),
      Specular$dDom$dElement.class_("u-btn-unstyled u-va-top btn-wrap text-muted js-popover"),
      Specular$dDom$dElement.attr("data-target")("#allergens-popover"),
      Specular$dDom$dElement.attr("data-title")(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.menu.allergens.label),
        {}
      )),
      Specular$dDom$dElement.attr("data-dismiss-btn")("close"),
      Specular$dDom$dElement.attr("data-template-content")(Data$dString$dCommon.joinWith(", ")(Data$dFunctor.arrayMap(allergen => Data$dShow.showIntImpl((() => {
        if (allergen.tag === "Gluten") { return 1; }
        if (allergen.tag === "Crustaceans") { return 2; }
        if (allergen.tag === "Eggs") { return 3; }
        if (allergen.tag === "Fish") { return 4; }
        if (allergen.tag === "Peanuts") { return 5; }
        if (allergen.tag === "Soybeans") { return 6; }
        if (allergen.tag === "Milk") { return 7; }
        if (allergen.tag === "Nuts") { return 8; }
        if (allergen.tag === "Celery") { return 9; }
        if (allergen.tag === "Mustard") { return 10; }
        if (allergen.tag === "Sesame") { return 11; }
        if (allergen.tag === "SulphurDioxide") { return 12; }
        if (allergen.tag === "Lupin") { return 13; }
        if (allergen.tag === "Molluscs") { return 14; }
        $runtime.fail();
      })()) + ". " + Restaumatic$dMenu$dV2$dAllergens.translatedAllergen(allergen))(Data$dArray.sortWith(Data$dOrd.ordInt)(Restaumatic$dMenu$dV2$dTypes$dAllergen.toOfficialId)(toUnfoldable(details.allergens))))),
      Specular$dDom$dElement.attr("title")(""),
      Specular$dExtra$dPopover.advancedPopover
    ])(Specular$dDom$dElement.text(Data$dString$dCommon.joinWith(", ")(Data$dFunctor.arrayMap(Data$dShow.showIntImpl)(Data$dArray.sortBy(Data$dOrd.ordInt.compare)(Data$dFunctor.arrayMap(Restaumatic$dMenu$dV2$dTypes$dAllergen.toOfficialId)(toUnfoldable(details.allergens)))))));
    if (!$3) { return $4; }
    if ($3) { return Specular$dInternal$dRIO.pureImpl(); }
    $runtime.fail();
  }))))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("p")([Specular$dDom$dElement.class_("m-show-more d-flex flex-column js-showmore")])((() => {
    const inputId = getFieldId(selectionItem) + "-desc";
    return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("input")([
      Specular$dDom$dElement.attr("id")(inputId),
      Specular$dDom$dElement.class_("m-show-more__state js-showmore-state"),
      Specular$dDom$dElement.attr("type")("checkbox"),
      Specular$dDom$dElement.attr("aria-hidden")("true")
    ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
      Specular$dDom$dElement.class_("m-crossup__item-desc m-show-more__text js-showmore-element"),
      Specular$dExtra$dShowMore.showMore
    ])(Specular$dDom$dElement.text(details.description)))(() => Specular$dDom$dElement.el("label")([
      Specular$dDom$dElement.attr("for")(inputId),
      Specular$dDom$dElement.class_("m-show-more__trigger js-showmore-trigger"),
      Specular$dDom$dElement.attr("data-read-more")(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.theme.show_more),
        {}
      )),
      Specular$dDom$dElement.attr("data-read-less")(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.theme.show_less),
        {}
      ))
    ])(Restaumatic$dPrelude$dSpecular.wempty)));
  })()))(() => Specular$dDom$dElement.el("footer")([Specular$dDom$dElement.class_("d-flex justify-content-between align-items-baseline")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.class_("m-crossup__price")
  ])(Specular$dDom$dElement.text(Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(details.unitPrice))))(() => Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.class_("m-crossup__counter")
  ])((() => {
    const quantityD = Restaumatic$dForm$dInternal.queryLaxWithDefault(queryFormField$p1)(0)(Data$dRecord.unsafeGet("quantity")(selectionItem.subform));
    return Specular$dInternal$dRIO.bindImpl(whenD(Specular$dFRP$dBase.functorDynamic.map(v1 => v1 > 0)(quantityD))(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("button")([
      Specular$dDom$dElement.attr("type")("button"),
      Specular$dDom$dElement.class_("m-crossup__counter-btn m-crossup__counter-btn--subtract u-btn-unstyled"),
      Specular$dDom$dElement.attr("aria-label")(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.menu.remove),
        {}
      )),
      Specular$dDom$dElement.attr("role")("button"),
      Specular$dDom$dElement.onClick_(Restaumatic$dForm$dFormField.modify(Data$dRecord.unsafeGet("quantity")(selectionItem.subform))(v1 => v1 - 1 | 0))
    ])(Specular$dDom$dElement.el("span")([
      Specular$dDom$dElement.attrs(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
        const $3 = {};
        $3.class = "icon-minus icon-flex-center";
        return $3;
      })())((() => {
        const $3 = {};
        $3["aria-hidden"] = "true";
        return $3;
      })()))
    ])(Restaumatic$dPrelude$dSpecular.wempty)))(() => Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("m-crossup__counter-value")])(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(Data$dShow.showIntImpl)(quantityD))))))(() => Specular$dDom$dElement.el("button")([
      Specular$dDom$dElement.attr("type")("button"),
      Specular$dDom$dElement.class_("m-crossup__counter-btn m-crossup__counter-btn--add u-btn-unstyled"),
      Specular$dDom$dElement.attr("aria-label")(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.menu.add),
        {}
      )),
      Specular$dDom$dElement.attr("role")("button"),
      Specular$dDom$dElement.onClick_((() => {
        const $3 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(Data$dRecord.unsafeGet("add")(selectionItem.subform).effect._1);
        return () => {
          const e = $3();
          return e()();
        };
      })())
    ])(Specular$dDom$dElement.el("span")([
      Specular$dDom$dElement.attrs(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
        const $3 = {};
        $3.class = "icon-plus icon-flex-center";
        return $3;
      })())((() => {
        const $3 = {};
        $3["aria-hidden"] = "true";
        return $3;
      })()))
    ])(Restaumatic$dPrelude$dSpecular.wempty)));
  })())))))))))))))))));
  return withDynamic_(hasItems($1))(hasItems$p => {
    const $4 = Specular$dDom$dElement.el("fieldset")([Specular$dDom$dElement.class_("m-form__group")])(Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.class_("m-crossup splide splide--rwd js-slider"),
      $2 ? Specular$dDom$dElement.monoidProp.mempty : Specular$dDom$dElement.class_("u-small-spacing-y m-crossup--with-title"),
      $2 ? Specular$dDom$dElement.class_("u-py0") : Specular$dDom$dElement.monoidProp.mempty,
      Specular$dExtra$dSlider.slider()()({
        rewind: false,
        type: "slide",
        gap: "1rem",
        responsive: [
          Data$dTuple.$Tuple(Specular$dExtra$dSlider.ExtraSmall, Specular$dExtra$dSlider.$ResponsiveSlides(1)),
          Data$dTuple.$Tuple(Specular$dExtra$dSlider.Small, Specular$dExtra$dSlider.$ResponsiveSlides(2))
        ]
      })
    ])($3));
    if (hasItems$p) { return $4; }
    return Specular$dInternal$dRIO.pureImpl();
  });
};
const define = () => () => params => {
  const $0 = {...params};
  const $1 = $0.field;
  const $2 = $0.menu;
  const $3 = $0.menuConsumer;
  const $4 = $0.menuEnv;
  const $5 = $0.menuOrderOrigin;
  const catalogue = Data$dRecord.unsafeGet("catalogue")($2);
  const catalogueMemo = {catalogue, parametersMemo: {value: Data$dMap$dInternal.Leaf}};
  return Specular$dInternal$dRIO.bindImpl(getGlobalLocale)(locale => Specular$dInternal$dRIO.bindImpl(uniqFinal($0.productIds))(productIdsF => Specular$dInternal$dRIO.bindImpl(getImplementation(catalogue))(implementation => Specular$dInternal$dRIO.bindImpl(asyncRequest((() => {
    const $6 = getWeights($0.restaurantId)(implementation);
    return (() => {
      const n = Specular$dInternal$dIncremental.constant($6);
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })();
  })()))(weightsD => Specular$dInternal$dRIO.bindImpl(mapEffectF1(sequenceRecord({
    productIds: productIdsF,
    weights: Restaumatic$dForm$dFinal.makeFinal(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(weightsD))
  }))(v1 => {
    if (v1.weights.tag === "NotRequested") { return () => []; }
    if (v1.weights.tag === "Loading") { return () => []; }
    if (v1.weights.tag === "Loaded") {
      return Restaumatic$dCrossSelling$dSuggestions.computeSuggestedItems({
        catalogueMemo,
        menu: $2,
        menuEnv: $4,
        menuConsumer: $3,
        implementation,
        locale,
        menuOrderOrigin: $5,
        productIds: v1.productIds,
        weights: v1.weights._1,
        maxItems: 8
      });
    }
    $runtime.fail();
  }))(suggestedItems => Specular$dInternal$dRIO.bindImpl(() => ({value: Data$dMap$dOrdered.$OMap(Data$dMap$dInternal.Leaf, [])}))(shownProducts => Specular$dInternal$dRIO.bindImpl(() => (
    {value: mempty2}
  ))(chosenProductsForExternalState => Specular$dInternal$dRIO.bindImpl((() => {
    const $6 = $1.selections;
    return Restaumatic$dForm$dInternal.traverse_(v => v($6))([
      (() => {
        const $7 = Restaumatic$dForm$dInternal.unFinalWithDefault([])(Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Data$dFunctor.arrayMap(v1 => v1.itemId)))(suggestedItems));
        return v1 => v1.keys._2(_old => $7);
      })(),
      item(selectionItem => {
        const itemId = selectionItem.key;
        const itemF = Restaumatic$dForm$dInternal.mapMaybeFinalInternal("CrossSellingListItem not found")(Data$dFoldable.find(Data$dFoldable.foldableArray)(x => x.itemId === itemId))(suggestedItems);
        return Specular$dInternal$dRIO.bindImpl((() => {
          const $7 = Data$dRecord.unsafeGet("quantity")(selectionItem.subform);
          return Restaumatic$dForm$dInternal.traverse_(v => v($7))([
            (() => {
              const $8 = Restaumatic$dForm$dFinal.applicativeFinal.pure(0);
              return v1 => v1.defaultValue._2(_old => $8);
            })()
          ]);
        })())(() => Specular$dInternal$dRIO.bindImpl((() => {
          const $7 = Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Data$dRecord.unsafeGet("content")))(Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Data$dRecord.unsafeGet("item")))(itemF));
          return Data$dRecord.unsafeGet("productKey")(selectionItem.subform).value._2(_old => $7);
        })())(() => Specular$dInternal$dRIO.bindImpl((() => {
          const $7 = Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Data$dRecord.unsafeGet("details")))(itemF);
          return Data$dRecord.unsafeGet("details")(selectionItem.subform).value._2(_old => $7);
        })())(() => Specular$dInternal$dRIO.bindImpl((() => {
          const $7 = (() => {
            if ($0.mode.tag === "InternalState") { return Restaumatic$dForm$dFormField.modify(Data$dRecord.unsafeGet("quantity")(selectionItem.subform))(v2 => v2 + 1 | 0); }
            if ($0.mode.tag === "ExternalState") {
              const $7 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(queryLax(Data$dRecord.unsafeGet("productKey")(selectionItem.subform))));
              return () => {
                const m_productKey = $7();
                return for_(m_productKey)(productKey => {
                  const $8 = $0.mode._1.addItem(productKey);
                  return () => {
                    $8();
                    const $9 = chosenProductsForExternalState.value;
                    chosenProductsForExternalState.value = Data$dMap$dInternal.insert(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.ordCartProductKey)(productKey)()($9);
                  };
                })();
              };
            }
            $runtime.fail();
          })();
          return Data$dRecord.unsafeGet("add")(selectionItem.subform).effect._2(_old => v => $7);
        })())(() => {
          const $7 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(itemF));
          const $8 = implementation.tag === "Automatic"
            ? (() => {
                const m_item = $7();
                return for_(m_item)(item1 => {
                  const productId = Data$dRecord.unsafeGet("productId")((() => {
                    const $8 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, Data$dRecord.unsafeGet("parts")(Data$dRecord.unsafeGet("content")(item1.item)), 0);
                    if ($8.tag === "Just") { return $8._1; }
                    $runtime.fail();
                  })());
                  return () => {
                    const shown = shownProducts.value;
                    const $8 = Data$dMap$dOrdered.member(Data$dOrd.ordString)(Data$dEq.eqString)(productId)(shown);
                    const $9 = insert1(productId)({
                      productId,
                      unitPrice: item1.details.unitPrice,
                      hasPhoto: (() => {
                        if (item1.details.photo.tag === "Nothing") { return false; }
                        if (item1.details.photo.tag === "Just") { return true; }
                        $runtime.fail();
                      })()
                    });
                    if (!$8) {
                      const $10 = shownProducts.value;
                      shownProducts.value = $9($10);
                      return Effect$dConsole.log("[CrossSelling] Product shown: " + productId)();
                    }
                    if ($8) { return; }
                    $runtime.fail();
                  };
                })();
              })
            : () => {};
          return Data$dRecord.unsafeGet("onVisible")(selectionItem.subform).effect._2(_old => v => $8);
        }))));
      })
    ]);
  })())(() => Specular$dInternal$dRIO.bindImpl((() => {
    const $6 = Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Data$dFunctor.arrayMap(Data$dTuple.snd)))(query($1.selections));
    return $1.result.value._2(_old => $6);
  })())(() => Specular$dInternal$dRIO.bindImpl((() => {
    const $6 = Data$dFunctor.arrayMap(v1 => v1._2.quantity * v1._2.details.unitPrice | 0);
    const $7 = Specular$dFRP$dBase.functorDynamic.map(m => {
      if (m.tag === "Left") { return Data$dEither.$Either("Left", m._1); }
      if (m.tag === "Right") { return Data$dEither.$Either("Right", sum($6(m._1))); }
      $runtime.fail();
    })(query1($1.selections));
    return $1.total.value._2(_old => $7);
  })())(() => {
    const $6 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(Restaumatic$dForm$dInternal.queryLaxWithDefault({
      queryWith: v => Restaumatic$dForm$dFinal.functorFinal.map(a => a)
    })([])($0.productIds));
    return Specular$dInternal$dRIO.bindImpl(getPresentation($0.list)(implementation))(presentation => Specular$dInternal$dRIO.bindImpl((() => {
      const $7 = Restaumatic$dForm$dFinal.applicativeFinal.pure(presentation);
      return $1.presentation.value._2(_old => $7);
    })())(() => $1.finished.effect._2(_old => v => () => {
      const productIds = $6();
      const shownSuggestions = shownProducts.value;
      const chosenSuggestions = (() => {
        if ($0.mode.tag === "InternalState") {
          const selections = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(Restaumatic$dForm$dInternal.unFinalWithDefault([])(query2($1.selections)))();
          return Data$dFunctor.arrayMap(v2 => (
            {
              productId: Data$dRecord.unsafeGet("productId")((() => {
                const $7 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, Data$dRecord.unsafeGet("parts")(v2._2.productKey), 0);
                if ($7.tag === "Just") { return $7._1; }
                $runtime.fail();
              })()),
              quantity: v2._2.quantity,
              unitPrice: v2._2.details.unitPrice
            }
          ))(selections);
        }
        if ($0.mode.tag === "ExternalState") {
          const products = chosenProductsForExternalState.value;
          return $$for(Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr, products))(productKey => {
            const $7 = $0.mode._1.quantityAndPrice(productKey);
            return () => {
              const info = $7();
              return {
                productId: Data$dRecord.unsafeGet("productId")((() => {
                  const $8 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, Data$dRecord.unsafeGet("parts")(productKey), 0);
                  if ($8.tag === "Just") { return $8._1; }
                  $runtime.fail();
                })()),
                quantity: info.quantity,
                unitPrice: info.unitPrice
              };
            };
          })();
        }
        $runtime.fail();
      })();
      const result = {
        restaurantId: $0.restaurantId,
        mainProducts: productIds,
        shownSuggestions: Data$dFunctor.arrayMap(Data$dTuple.snd)(shownSuggestions._2),
        chosenSuggestions: Data$dArray.filterImpl(x => Data$dRecord.unsafeGet("quantity")(x) > 0, chosenSuggestions),
        list: $0.list
      };
      const $7 = Data$dRecord.unsafeGet("shownSuggestions")(result).length === 0;
      if (!$7) {
        const currency = Utils$dTracking.getCurrencyEff();
        return Utils$dTracking.trackEventEff(Utils$dTracking.toNamedEvent(currency)(Restaumatic$dAnalytics$dTypes$dEvent.$Event("SuggestionResult", result)))();
      }
      if ($7) { return; }
      $runtime.fail();
    })));
  }))))))))));
};
export {
  $Mode,
  ExternalState,
  InternalState,
  addIsSymbol,
  asyncRequest,
  define,
  detailsIsSymbol,
  display,
  display1,
  $$for as for,
  for_,
  getAcsWeights,
  getExperimentVariant,
  getExperimentVariant1,
  getExperimentVariant2,
  getFieldId,
  getGlobalLocale,
  getImplementation,
  getPresentation,
  getWeights,
  hasItems,
  insert1,
  item,
  mapEffect,
  mapEffectF,
  mapEffectF1,
  mempty,
  mempty2,
  monadFRP,
  monadFRP1,
  onVisibleIsSymbol,
  productKeyIsSymbol,
  quantityIsSymbol,
  query,
  query1,
  query2,
  queryFormField$p1,
  queryLax,
  queryReadOnly$p1,
  queryRecordCons,
  queryRecordCons1,
  sequenceRecord,
  setExperimentVariant,
  sum,
  toUnfoldable,
  traverse,
  traverse_,
  uniqFinal,
  whenD,
  withDynamic_
};
